import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { APP_CONNECT_PLUGIN_DETAIL_PATH_OAUTH2_CALLBACK } from '@/libs'
import { getLastCompanyId, getLastGameId } from '@/Settings'
import { getUrlParams } from '@/auth/useAuthToken'
import { FullscreenLayout } from '@/components/layouts'

export const AppConnectOAuthCallback = () => {
  const navigate = useNavigate()
  const { pluginSlug } = useParams()

  useEffect(() => {
    const hash = window.location.hash.substring(1)
    const params = new URLSearchParams(hash)

    const accessToken = params.get('access_token') || getUrlParams()['access_token']

    navigate(
      generatePath(APP_CONNECT_PLUGIN_DETAIL_PATH_OAUTH2_CALLBACK, {
        companyId: getLastCompanyId(),
        gameId: getLastGameId(),
        pluginSlug: pluginSlug || '',
      }) + `?access_token=${accessToken}`,
    )
  }, [])

  return <FullscreenLayout isLoading={true} />
}
